import { Controller, useFormContext } from "react-hook-form";
import { ReportControlPointCreate, ReportType } from "../../../types/api/report";
import {
    Box,
    FormControl,
    FormHelperText,
    InputLabel,
    MenuItem,
    Select,
    SelectChangeEvent,
    TextField,
} from "@mui/material";
import { useContext } from "react";
import { MainContextState, MainContext } from "../../../context/MainContext";

export const CreateForm = () => {
    const { control } = useFormContext<ReportControlPointCreate>();
    const { constants } = useContext<Partial<MainContextState>>(MainContext);
    const reportTypes = constants?.export_type?.filter(item => item.text.includes("Форма"));

    return (
        <Box
            component="form"
            sx={{
                "& .MuiTextField-root": { my: 1 },
            }}
            noValidate
            autoComplete="off">
            <div>
                <Controller
                    defaultValue={""}
                    name={"name"}
                    control={control}
                    rules={{
                        required: true,
                        maxLength: {
                            value: 120,
                            message: "Максимальная длина 120 символов",
                        },
                    }}
                    render={({ field, fieldState }) => {
                        return (
                            <TextField
                                {...field}
                                size={"small"}
                                InputLabelProps={{
                                    shrink: true,
                                }}
                                fullWidth
                                label={"Наименование"}
                                error={!!fieldState.error}
                                helperText={fieldState.error?.message}
                            />
                        );
                    }}
                />
            </div>
            <div>
                <Controller
                    defaultValue={""}
                    control={control}
                    name="expired_at"
                    render={({ field: { onChange, value, ...field }, fieldState }) => (
                        <TextField
                            {...field}
                            size={"small"}
                            InputLabelProps={{
                                shrink: true,
                            }}
                            type="date"
                            fullWidth
                            label="Дата"
                            onChange={(e: any) => {
                                onChange(e.target.value.replace(/-/g, "/"));
                            }}
                            value={value?.slice(0, 10).replace(/\//g, "-")}
                            autoComplete="off"
                            error={!!fieldState.error}
                            helperText={fieldState.error?.message}
                        />
                    )}
                />
            </div>
            <div>
                <Controller
                    defaultValue={undefined}
                    name={"report_type"}
                    control={control}
                    render={({ field: { onChange, value }, fieldState }) => (
                        <FormControl sx={{ width: "100%", my: 1 }}>
                            <InputLabel id={"center-state-label"}>Форма отчетности</InputLabel>
                            <Select
                                size={"small"}
                                fullWidth
                                labelId={"center-state-label"}
                                label={"Состояние статуса"}
                                onChange={(event: SelectChangeEvent) => {
                                    onChange(event.target.value as unknown as ReportType);
                                }}
                                value={value as unknown as string}
                                defaultValue={" "}
                                autoComplete="off"
                                error={!!fieldState.error}>
                                {reportTypes?.map(state => (
                                    <MenuItem key={state.value} value={state.value}>
                                        {state.text}
                                    </MenuItem>
                                ))}
                            </Select>
                            <FormHelperText>{fieldState.error?.message}</FormHelperText>
                        </FormControl>
                    )}
                />
            </div>

            <div>
                <Controller
                    defaultValue={""}
                    name={"description"}
                    control={control}
                    rules={{
                        required: true,
                        maxLength: {
                            value: 120,
                            message: "Максимальная длина 120 символов",
                        },
                    }}
                    render={({ field, fieldState }) => {
                        return (
                            <TextField
                                {...field}
                                size={"small"}
                                InputLabelProps={{
                                    shrink: true,
                                }}
                                fullWidth
                                label={"Описание"}
                                error={!!fieldState.error}
                                helperText={fieldState.error?.message}
                            />
                        );
                    }}
                />
            </div>
        </Box>
    );
};
